import { DesignInfoInputDialogState } from ".";
import { InDefCommonFlagType } from "../../../util/general-code/enums/general-codes";
import { TaskList } from "../../component-project-detail";

export const DesignInfoInputDialogInitialState: DesignInfoInputDialogState = {
  task: {} as TaskList,
  designInfo: "",
  isShow: false,
  isEdited: true,
  reqTskSlctdFlg: InDefCommonFlagType.NO,
  formValidation: true,
};
